import ClientTable from '../ClientTable';
import DashboardTableHeader from './DashboardTableHeader';

export default function DashboardTableClients() {
    return (
        <>
            <DashboardTableHeader />
            <ClientTable />
        </>
    )
}